import React from "react"

const PhoneWhite = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Path"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6786 20.1787L19.2344 23.234C15.4489 21.0093 12.2941 17.8548 10.069 14.0695L13.1244 11.6254C13.8606 11.0358 14.107 10.0241 13.7242 9.16206L10.9387 2.8908C10.5264 1.96159 9.50196 1.46752 8.5181 1.72337L3.21705 3.09858C2.19307 3.3661 1.53106 4.35725 1.67615 5.40559C3.58772 19.0171 14.2861 29.7151 27.8979 31.6266C28.946 31.7713 29.9368 31.1094 30.2043 30.0858L31.5795 24.7842C31.8348 23.8006 31.3413 22.7766 30.4128 22.3636L24.1421 19.5789C23.28 19.1959 22.2681 19.4423 21.6786 20.1787Z"
        fill="white"
      />
    </svg>
  )
}

export default PhoneWhite
